import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import Select from "react-select";
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import {ValidSelect} from "beaktShared/helpers/validselect";
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import MenuBar from "beaktShared/components/TipTap/MenuBar";
import TextAlign from '@tiptap/extension-text-align'

// icons
import DescriptionIcon from '@material-ui/icons/Description';
import Check from "@material-ui/icons/Check";
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

import {UsePostApi, UsePutApi} from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import "assets/css/tiptap.css";

const useStyles = makeStyles(styles);

export default function ClausulaContratoForm({ addItem, item, handleView }) {
    const { t } = useTranslation(); 
    const classes = useStyles();   
    const session = useContext(SessionContext);

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    
    const showNotification = (mensagem,color) => { 
          setMensagemNotification(mensagem);
          setColorNotification(color);      
          setNotification(true);
          setTimeout(function() {
              setNotification(false);
          }, 6000);       
    };

    const {register, handleSubmit, setValue,setError, errors, clearError } = useForm({mode: "onBlur"});
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true); 
    const [clausulaPadrao, setclausulaPadrao] = React.useState(true); 
    const endPoint = 'clausulacontrato/';  

    const [loadingForm, setLoadingForm] = React.useState(false);

    const [file, setFile] = React.useState(null);

    const [clausulaContratoId, setclausulaContratoId] = React.useState(0);

    const _editor = useEditor({
        extensions: [
          StarterKit,
          Document,
          Text,
          TextAlign.configure({
            types: ['heading', 'paragraph'],
          }),
        ],
        content: item.arquivo,
      })

    const handleArquivoChange = event => {       
        const arquivo = event.target.files[0];                
        const fileReader = new FileReader();
        fileReader.onload = function (oFREvent) {                    
            setFile(oFREvent.target.result);
        }
        fileReader.readAsDataURL(arquivo)
    }

    const intialValues = {
        clausulaContratoId:0,
        descricao:'',
        ativo:false,  
        clausula: false,
    };

    useEffect(() => {
        LoadDadosItem(item);    
    }, [item]);

    const LoadDadosItem =(item) =>{        
        if(!item.clausulaContratoId)
            return; 

        setValue('clausulaContratoId', (item.clausulaContratoId === null ? 0 : item.clausulaContratoId));
        setclausulaContratoId((item.clausulaContratoId === null ? 0 : item.clausulaContratoId));
        setValue('descricao',item.descricao);                
        setValue('ativo',item.ativo);        
        setAtivoCheckbox(item.ativo);
        setValue('clausula',item.clausulaPadrao);        
        setclausulaPadrao(item.clausulaPadrao);
        setValue('arquivo',item.arquivo);        
    }

    const onSubmit = (data, e) => {        
        e.preventDefault();        
      
        let file = _editor.getHTML();
       
        if(file == ""){
            return setError("arquivo", "", t('information_message.the_clause_field_is_empty'));

        } 
        else
        {
            let item ={
                clausulaContratoId: (clausulaContratoId === null ? 0 : clausulaContratoId),
                descricao: data.descricao,
                ativo: ativoCheckbox,
                arquivo: file,
                usuarioCadastroId:session.id,
                clausulaPadrao: clausulaPadrao,
                franquiaId: session.franquiaId
           }        
           
           setLoadingForm(true);
            if (item.clausulaContratoId === null || item.clausulaContratoId === 0){
                
                UsePostApi(endPoint,item).then(result=>{            
                    if(result.status !== 200 && result.status !== 201)
                    {                         
                        showNotification(result.message.message,'danger');
                        setLoadingForm(false);
                        return false; 
                    } 

                    addItem(result.data, result.message);
                    return true;                
                }); 
            }
            else{
                UsePutApi(endPoint,item.clausulaContratoId,item).then(result=>{
                    if(result.status !== 200 && result.status !== 201)
                    {                                    
                        showNotification(result.message.message,'danger');
                        setLoadingForm(false);
                        return false; 
                    }

                    setLoadingForm(false);
                    addItem(result.data, result.message);
                    return true;                 
                });
            }
        }      
    };

    const handleViewForm = () => {
        handleView();
    };
   
    return (
        <div className="maxContent">             
            <form onSubmit={handleSubmit(onSubmit)}>
                
                <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
                />
                
                <GridContainer className={classes.marginTopCard}>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <DescriptionIcon />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                        {t('information_message.registration_of_contract_clausules')} - <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.clausulaContratoId} name="clausulaContratoId" ref={register} />                                
                                </h4>
                            </CardHeader>
                            <CardBody className={classes.cardMargin}>
                                
                            <GridContainer>                                                                                    
                                <GridItem xs={12} sm={12} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                        <TextField                                        
                                            error={errors.descricao?true:false}
                                            label={t('label.description')}
                                            variant="outlined"                                    
                                            inputRef={register({required: true})}
                                            name="descricao"
                                            defaultValue={intialValues.descricao}  
                                            InputLabelProps={{shrink: true}} 
                                            inputProps={{maxLength: 150}}                                      
                                        />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.descricao && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>   
                            </GridContainer>                              
                            <GridContainer>      
                                <GridItem xs={6} sm={6} md={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={clausulaPadrao}   
                                                onClick={event => {setclausulaPadrao(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="clausula"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('label.standard_clause')}
                                    />
                                </GridItem>                                                                            
                                <GridItem xs={6} sm={6} md={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')}
                                    />
                                </GridItem>                                 
                            </GridContainer>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                <p className="text-danger">*Para inserir a tabela de itens do contrato com valores, use a TAG<strong className="font-weight-bold"> #TABLE2 </strong>no lugar desejado</p>

                                <div style={{"height": "300px", "border": "1px solid #999999", "border-radius": "5px", "padding": "10px", "overflow-y": "auto"}}>
                                    <MenuBar editor={_editor}> </MenuBar>
                                    <EditorContent editor={_editor} style={{"width": "100%"}} name="arquivo"></EditorContent>
                                </div>
                                </GridItem>  
                            </GridContainer>
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')}
                            {loadingForm && <div>...{t('label.loading')}</div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
        </form>
    </div>
    );
}
